<template>
  <b-alert show :variant="statusInfo.variant" class="mb-4">
    <div class="d-flex align-items-start">
      <i :class="[statusInfo.icon, 'mr-3', 'mt-1', 'fa-lg']" />
      <div>
        <strong>{{ statusInfo.title }}</strong>
        <span class="d-block mt-1">{{ statusInfo.description }}</span>
        <strong v-if="statusInfo.boldNote" class="d-block mt-1">{{ statusInfo.boldNote }}</strong>
      </div>
    </div>
  </b-alert>
</template>

<script>
import {
  PENDING_STATUS,
  getDiberikanTunai,
  getNominalKekurangan,
} from './disbursementPendingUtils'

export default {
  name: 'DisbursementPendingStatusAlert',
  props: {
    disbursementPending: {
      type: Object,
      default: () => ({}),
    },
    transaction: {
      type: Object,
      required: true,
    },
  },
  computed: {
    PENDING_STATUS() {
      return PENDING_STATUS
    },
    diberikanTunai() {
      return getDiberikanTunai(this.disbursementPending)
    },
    nominalKekurangan() {
      return getNominalKekurangan(this.transaction, this.disbursementPending)
    },
    hasShortfall() {
      return this.nominalKekurangan > 0
    },
    statusInfo() {
      const status = this.transaction.status

      if (status === this.PENDING_STATUS.WAITING_BANK_RESPONSE) {
        return {
          variant: 'info',
          title: 'Menunggu respons bank',
          description: 'Sedang menunggu konfirmasi dari bank.',
          icon: 'fa fa-clock-o',
        }
      }

      if (status === this.PENDING_STATUS.PROCESS_SHORTFALL) {
        return {
          variant: 'danger',
          title: 'Proses kekurangan dana',
          description: `Finance perlu transfer kekurangan Rp. ${this.formatAmount(this.nominalKekurangan)} ke rekening nasabah.`,
          icon: 'fa fa-exclamation-circle',
        }
      }

      if (status === this.PENDING_STATUS.PROCESS_REFUND) {
        return {
          variant: 'primary',
          title: 'Proses pengembalian dana',
          description: `Nasabah mengembalikan Rp. ${this.formatAmount(this.diberikanTunai)} ke PGI.`,
          icon: 'fa fa-retweet',
        }
      }

      if (status === this.PENDING_STATUS.COMPLETED) {
        return {
          variant: 'success',
          title: 'Selesai',
          description: 'Proses transaksi ini selesai.',
          icon: 'fa fa-check-circle',
        }
      }

      return {
        variant: 'warning',
        title: 'Dana disbursement ditangguhkan',
        description: this.hasShortfall
          ? `Total diterima nasabah melebihi maksimal tunai. Jika berhasil, nasabah mengembalikan Rp. ${this.formatAmount(this.diberikanTunai)}. Jika gagal, kekurangan ditransfer manual oleh Finance.`
          : 'Cetak surat pernyataan, unggah dokumen, konfirmasi penyerahan dana tunai.',
        boldNote: '(Jika nasabah bersedia menunggu T+1, proses ini tidak perlu dilanjutkan).',
        icon: 'fa fa-exclamation-triangle',
      }
    },
  },
  methods: {
    formatAmount(value) {
      return this.$helper.addThousandSeparator(value || 0)
    },
  },
}
</script>
